﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class KDMZFreitext extends TKCustomElementFactory {
    url?: string;
    fieldElement?: HTMLTextAreaElement;
    quantity?: HTMLInputElement;
    submitButton?: HTMLButtonElement;

    constructor() {
        super();

        this.url = this.getAttribute('data-tk-url') || undefined;
        this.fieldElement = this.querySelector('textarea[name="textarea-freitext"]') || undefined;
        this.quantity = this.querySelector('input[name="input_dim1"]') || undefined;
        this.submitButton = this.querySelector<HTMLButtonElement>('[data-tk-freitext-submit]') || undefined;
    }

    connectedCallback(): void {
        if (!this.url || !this.fieldElement || !this.submitButton || !this.quantity)
            throw new Error('KDMZFreitext: Elements are missing!');

        this.registerSubmitListener();
    }

    registerSubmitListener() {
        const onSave = this.saveOrder.bind(this);
        this.pushListener({ event: 'click', element: this.submitButton!, action: onSave });
    }

    saveOrder() {
        const data = {
            value: this.fieldElement!.value,
            quantity: this.quantity!.value,
        };

        fetchRequest({
            requestURL: this.url!,
            resolveHandler: this.renderResult.bind(this),
            payload: data,
        });
    }

    renderResult(response: TKResponse) {
        if (!response) return;
        // const tabBasket = this.closest('.tk-minibasket__content')?.querySelector(
        //     '[data-minibasket-tab-basket]',
        // ) as HTMLButtonElement;
        // if (!tabBasket || !response.success) return;
        // tabBasket.click();
        const dialogClose = this.closest('.tk-dialog')?.querySelector('.tk-dialog__close') as HTMLButtonElement;
        if (!dialogClose || !response.success) return;
        // dialogClose.click();
        location.reload();
    }
}
